import React, { useState } from 'react';
import { StyleSheet } from 'react-native';

import EditUserAddressForm from 'shared/modules/account/components/organisms/EditUserAddressForm';
import EditUserDateOfBirthForm from 'shared/modules/account/components/organisms/EditUserDateOfBirthForm';
import EditUserNameForm from 'shared/modules/account/components/organisms/EditUserNameForm';
import EditUserProfileInstructions from 'shared/modules/account/components/organisms/EditUserProfileInstructions';
import EditUserProfileOTP from 'shared/modules/account/components/organisms/EditUserProfileOTP';
import Dialog from 'shared/modules/common/components/atoms/Dialog';
import SuccessFail from 'shared/modules/common/components/organisms/SuccessFail';

type InformationToEdit = 'name' | 'address' | 'dateOfBirth';

type Props = {
  informationToEdit: InformationToEdit;
  open: boolean;
  onCloseButtonPress: () => void;
};

const information = {
  name: '名前',
  address: '住所',
  dateOfBirth: '生年月日',
};

const EditUserProfileDialog = (props: Props) => {
  const [counter, setCounter] = useState(0);

  const title = props.informationToEdit
    ? `${information[props.informationToEdit]}を変更する`
    : '';
  const successMessage = props.informationToEdit
    ? `${information[props.informationToEdit]}の変更が完了しました。`
    : '';

  return (
    <Dialog
      title={title}
      open={props.open}
      onCloseButtonPress={props.onCloseButtonPress}
      onClose={() => setCounter(-1)}
      id="edit-user-profile-dialog"
      handleOnMount={() => setCounter(0)}
      style={style.dialog}
    >
      {counter === 0 && (
        <EditUserProfileInstructions onNextButtonPress={() => setCounter(1)} />
      )}
      {counter === 1 && <EditUserProfileOTP onSuccess={() => setCounter(2)} />}
      {counter === 2 && props.informationToEdit === 'address' && (
        <EditUserAddressForm onSuccess={() => setCounter(3)} />
      )}
      {counter === 2 && props.informationToEdit === 'dateOfBirth' && (
        <EditUserDateOfBirthForm onSuccess={() => setCounter(3)} />
      )}
      {counter === 2 && props.informationToEdit === 'name' && (
        <EditUserNameForm onSuccess={() => setCounter(3)} />
      )}
      {counter === 3 && (
        <SuccessFail message={{ success: successMessage }} success />
      )}
    </Dialog>
  );
};

export default EditUserProfileDialog;
export { InformationToEdit };

const style = StyleSheet.create({
  dialog: {
    maxHeight: 624,
  },
});
